import { VToastContext } from './context';
import type { VToastContextValue } from './type';

export const useVToast = (): VToastContextValue => VToastContext.hook();
